import * as React from 'react';
import { Typography } from '@mui/material';
var AccuracyStat = function (_a) {
    var averagePercentage = _a.averagePercentage;
    return (React.createElement("div", { style: {
            padding: '1rem 0',
            display: 'flex',
            gap: 10,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-around',
        } },
        React.createElement(Typography, { variant: "h5", component: "h5", sx: { fontWeight: 'bold' } }, "\u0422\u043E\u0447\u043D\u043E\u0441\u0442\u044C"),
        React.createElement(Typography, { variant: "h3", component: "h3", sx: {
                height: 150,
                width: 150,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '5px solid #d2cdcd',
                boxShadow: '0 0 .5rem gray',
                padding: '.5rem .5rem',
                borderRadius: 100,
            } },
            averagePercentage,
            "%")));
};
export default AccuracyStat;
